import { useEffect } from 'react';
import { createPortal } from 'react-dom';

export default function FilePreviewModal({ url, filename, onClose }) {
  useEffect(() => {
    function onKey(e) { if (e.key === 'Escape') onClose(); }
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  if (!url) return null;

  const ext = (filename || '').split('.').pop().toLowerCase();
  const isImage = ['png', 'jpg', 'jpeg', 'gif', 'webp'].includes(ext);
  const isPdf = ext === 'pdf';

  return createPortal(
    <>
      <div className="file-preview-backdrop" onClick={onClose} />
      <div className="file-preview-modal">
        <div className="file-preview-topbar">
          <span className="file-preview-name">{filename || 'File'}</span>
          <div className="file-preview-actions">
            <a href={url} target="_blank" rel="noopener noreferrer" className="file-preview-download">Open in tab</a>
            <button className="file-preview-close" onClick={onClose} aria-label="Close">×</button>
          </div>
        </div>
        <div className="file-preview-body">
          {isPdf && <iframe src={url} className="file-preview-iframe" title={filename} />}
          {isImage && <img src={url} alt={filename} className="file-preview-img" />}
          {!isPdf && !isImage && (
            <div className="file-preview-fallback">
              <div className="file-preview-fallback-name">{filename}</div>
              <a href={url} target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-sm">Download</a>
            </div>
          )}
        </div>
      </div>
    </>,
    document.body
  );
}
